"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultBoundingClientRect = exports.createVirtualElement = void 0;
var getDefaultBoundingClientRect = function getDefaultBoundingClientRect() {
  return {
    bottom: 9999,
    height: 0,
    left: -9999,
    right: 9999,
    top: -9999,
    width: 0,
    x: 0,
    y: 0
  };
};
exports.getDefaultBoundingClientRect = getDefaultBoundingClientRect;
var createVirtualElement = function createVirtualElement() {
  return {
    getBoundingClientRect: getDefaultBoundingClientRect
  };
};
exports.createVirtualElement = createVirtualElement;